export default "__VITE_ASSET__A1Y0wHGMHMn7kvWJCu_Mig__"